<template>
    <div>
        <b-row>
            <b-col cols="12">
                <div class="solution-steps">
                    <b-tabs pills content-class="mt-4" align="center">
                        <b-tab title="Calculate" @click="emitEvent('reset-shows-props')">
                        </b-tab>
                        <b-tab title="Other Cases" :active="showOtherLoanSelection" @click="emitEvent('show-otherloan-selection')">
                            <OtherLoanSelection />
                        </b-tab>
                        <b-tab title="Summary" :active="showOtherLoanSummary" @click="emitEvent('show-otherloan-summary')">
                            <OtherLoanSummary />
                        </b-tab>
                    </b-tabs>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import { Tabs, TabPane } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import OtherLoanSelection from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/OtherLoanSolution/OtherLoanSelection'
import OtherLoanSummary from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerSolutionScenario/OtherLoanSolution/OtherLoanSummary'

export default {
    props: {
        showOtherLoanSelection: Boolean,
        showOtherLoanSummary: Boolean,
    },
    components: {
        OtherLoanSelection,
        OtherLoanSummary,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    methods: {
        emitEvent(eventName) {
            solutionEventBus.$emit(eventName)
        },
    },
}
</script>